<div class="table-pagination" *ngIf="totalItems > 0">
  <label class="table-pagination-size">
    <span>Mostrar</span>
    <select [value]="pageSize" (change)="onPageSizeChange($event)" aria-label="Cantidad de registros por pagina">
      <option *ngFor="let option of pageSizeOptions" [value]="option">{{ option }}</option>
    </select>
  </label>

  <p class="table-pagination-summary">
    Mostrando {{ firstItem }}-{{ lastItem }} de {{ totalItems }}
  </p>

  <nav class="table-pagination-nav" aria-label="Paginacion de resultados">
    <span class="page-indicator">P&aacute;gina {{ safePage }} de {{ totalPages }}</span>
    <button type="button" class="pager-button" (click)="goPrevious()" [disabled]="isFirstPage" aria-label="Pagina anterior">&lsaquo;</button>
    <button type="button" class="pager-button" (click)="goNext()" [disabled]="isLastPage">Siguiente</button>
  </nav>
</div>
